<!-- Chat Container -->
<div class="chat-container">
  <!-- Chat Header -->
  <div class="chat-header">
    <div class="chat-header-info">
      <h2>{{ currentClientName || 'Chat' }}</h2>
      <span class="status-badge" *ngIf="isOnline">Online</span>
    </div>
    <div class="chat-actions">
      <button class="btn btn-icon" title="Atualizar" >
        <i class="fas fa-sync-alt"></i>
      </button>
    </div>
  </div>

  <!-- Chat Content -->
  <div class="chat-content">
    <!-- Chat Main -->
    <div class="chat-main">
      <!-- Chat Messages -->
      <div class="chat-messages" #messagesContainer>
        <ng-container *ngIf="currentClientId">
          <!-- Message Groups -->
          <div class="message-group" *ngFor="let message of messages">
            <div class="message-date">{{ formatMessageDate(message.timestamp) }}</div>
            
            <!-- Message -->
            <div class="message" [class.received]="message.senderId !== 0" [class.sent]="message.senderId === 0">
              <div class="message-avatar" *ngIf="message.senderId !== 0">
                <img [src]="message.senderAvatar" [alt]="message.senderName">
              </div>
              <div class="message-content">
                <div class="message-header">
                  <span class="sender-name" *ngIf="message.senderId !== 0">{{ message.senderName }}</span>
                  <span class="message-time">{{ formatMessageTime(message.timestamp) }}</span>
                </div>
                <div class="message-text">
                  {{ message.content }}
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Empty State -->
        <div class="empty-state" *ngIf="!currentClientId">
          <i class="fas fa-comments"></i>
          <h3>Nenhum cliente selecionado</h3>
          <p>Selecione um cliente para iniciar uma conversa</p>
        </div>
      </div>

      <!-- Chat Input -->
      <div class="chat-input" *ngIf="currentClientId">
        <form [formGroup]="messageForm" (ngSubmit)="sendMessage()">
          <div class="input-actions">
            <!--<button type="button" class="btn btn-icon" title="Anexar arquivo">
              <i class="fas fa-paperclip"></i>
            </button>-->
          </div>
          <div class="message-input">
            <textarea 
              formControlName="message"
              class="form-control" 
              placeholder="Digite sua mensagem para {{ currentClientName }}..." 
              rows="1"
              (keydown.enter)="sendMessage()">
            </textarea>
          </div>
          <button type="submit" class="btn btn-primary send-button" [disabled]="!messageForm.valid">
            <i class="fas fa-paper-plane"></i>
          </button>
        </form>
      </div>
    </div>
  </div>
</div> 